export default __webpack_public_path__ + "static/media/ceramol-acne-acne-in-eta-adulta.9f479705.jpg";